import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AutoSaveService {
  private componentsWithUnsavedChanges = new Set<any>();

  registerComponent(component: any) {
    this.componentsWithUnsavedChanges.add(component);
  }

  unregisterComponent(component: any) {
    this.componentsWithUnsavedChanges.delete(component);
  }

  async checkAllComponentsForUnsavedChanges(): Promise<boolean> {
    for (const component of this.componentsWithUnsavedChanges) {
      {
        const canLeave = await component.canDeactivate();
        if (!canLeave) return false;
      }
    }
    return true;
  }
}
